/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { NAV_SQUARE_LOGO_SIZE } from 'bundles/unified-description-page-common/constants';

import _t from 'i18n!nls/xdp';

type Props = {
  leftImageSrc?: string;
  leftPartnerName?: string;
  rightImageSrc?: string;
  rightPartnerName?: string;
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
  `,
  divider: () => css`
    background: var(--cds-color-grey-50);
    height: ${NAV_SQUARE_LOGO_SIZE}px;
    width: 2px;
    margin: 0 var(--cds-spacing-200);
  `,
};

const HeroCoBrandingPartnerLogos = ({ leftImageSrc, leftPartnerName, rightImageSrc, rightPartnerName }: Props) => {
  if (!leftImageSrc && !rightImageSrc) {
    return null;
  }

  return (
    <div css={styles.container}>
      {leftImageSrc && (
        <Imgix
          src={leftImageSrc}
          alt={leftPartnerName || _t('Partner')}
          maxWidth={NAV_SQUARE_LOGO_SIZE}
          maxHeight={NAV_SQUARE_LOGO_SIZE}
        />
      )}
      {rightImageSrc && (
        <React.Fragment>
          {leftImageSrc && <div css={styles.divider} />}
          <Imgix
            src={rightImageSrc}
            alt={rightPartnerName || _t('Partner')}
            maxWidth={NAV_SQUARE_LOGO_SIZE}
            maxHeight={NAV_SQUARE_LOGO_SIZE}
          />
        </React.Fragment>
      )}
    </div>
  );
};

export default HeroCoBrandingPartnerLogos;
